export const DOCS_BASE_URL = process.env.NEXT_PUBLIC_WEB_DOCS_URL || ''

export const ACADEMY_BASE_URL = DOCS_BASE_URL

export const MAIN_CONTENT_SCROLL_TOP_OFFSET = 80

export const DOCS_ROUTES = {
  documentation: '',
  quickStart: '/quick-start',
} as const

export const DOCS_RESERVED_PATH_PREFIXES = ['/quick-start', '/auth', '/api'] as const

/** Route paths used by duplicated Academy components in the docs app. */
export const ACADEMY_ROUTES = {
  home: '/',
  quickStart: DOCS_ROUTES.quickStart,
  documentation: DOCS_ROUTES.documentation,
} as const

export const SECTION_REDIRECT_RULES = [{ path: '/', stripPrefix: /^docs\// }, { path: DOCS_ROUTES.quickStart }] as const

export const SIDEBAR_MENU_KEYS = {
  tutorial: 'tutorial-menu',
  normal: 'normal-menu',
  codeSandbox: 'code-sandbox-menu',
} as const

export const TUTORIAL_MENU_DEFAULTS = {
  basePath: ACADEMY_ROUTES.quickStart,
  title: 'Quick Start Guide',
} as const
